import { Versionable } from '../types/versionable';
import { LogLevel } from '../types/logLevel';

export enum EsmeBindMode {
  ALL = 'ALL',
  TRANSMITTER = 'TRANSMITTER',
  RECEIVER = 'RECEIVER',
  TRANSCEIVER = 'TRANSCEIVER',
  EMI_SESSION = 'EMI_SESSION',
  TRANSMITTER_TLS_SSL = 'TRANSMITTER_TLS_SSL',
  RECEIVER_TLS_SSL = 'RECEIVER_TLS_SSL',
  TRANSCEIVER_TLS_SSL = 'TRANSCEIVER_TLS_SSL',
}

export interface EsmeObject {
  readonly user: {
    readonly username: string;
    readonly password: string;
    readonly bindModes: EsmeBindMode[];
    readonly userAllowIps: string[];
    readonly defaultSmscIds: string[];
    readonly maxBinds: number;
    readonly maxReceiverBinds: number;
    readonly maxTransmitterBinds: number;
    readonly maxTransceiverBinds: number;
    readonly sessionTimeout: number;
    readonly logFile: string;
    readonly logLevel: LogLevel;
    readonly throughput: number;
    readonly throughputIn: number;
    readonly throughputOut: number;
  };
  readonly mtRoutes: Array<{
    readonly smscIds: string[];
    readonly receiverPrefixes: number[];
  }>;
  readonly moRoutes: Array<{
    readonly smscId: string;
    readonly receiverRegexes: string[];
  }>;
}

export interface EsmeModel extends Versionable {
  readonly object: EsmeObject;
}
